import { Outlet } from 'react-router-dom';
import { Auth } from '../../pages/Auth/page/Auth';
import { getTokenFromLocalStorage } from '../functions/getToken';

export const ProtectedRouter = () => {
  const token = getTokenFromLocalStorage();

  return token ? <Outlet /> : <Auth />;
};
